import { ConfirmationWithCommentWarningDialogData } from '../../shared/models/confirmation-with-comment-warning-dialog-data';

export const cancelReportRequestDialogWithCommentData: ConfirmationWithCommentWarningDialogData = {
  title: 'Cancel report request',
  displayText: 'Are you sure you want to Cancel the report generation?',
  confirmBtnName: 'Yes',
  cancelBtnName: 'No',
  inputPlaceholder: 'Reason to cancel',
  validationMessage: 'Enter text between 25 and 1000 characters',
  isConfirmed: false
};

export const deleteReportDialogWithCommentData: ConfirmationWithCommentWarningDialogData = {
  title: 'Delete Report',
  displayText: 'Are you sure you want to delete this report?',
  confirmBtnName: 'Delete',
  cancelBtnName: 'Cancel',
  inputPlaceholder: 'Reason to Delete',
  validationMessage: 'Enter text between 25 and 1000 characters',
  isConfirmed: false
};
